import React, { FunctionComponent, useState } from 'react'
import { Button, Card, Col, Row, Typography } from 'antd'
import { useIntegrationContext } from '../../../../context/integration'
import Banner from '../../../../images/register/member-register-promo.png'
import { useBrandContext } from '../../../../context/brand'

const { Title, Paragraph } = Typography

import './index.less'

type TMemberRegisterPromoProps = {
	isLogin?: boolean
}

const MemberRegisterPromo: FunctionComponent<TMemberRegisterPromoProps> = ({ isLogin }) => {
	const [open, setOpen] = useState<boolean>(false)
	const { integration } = useIntegrationContext()
	const { brand } = useBrandContext()
	const isChannelWise = brand?.currentBrand?.name === 'channelWise'

	if (integration.loading) {
		return null
	}

	if (!isLogin && !integration.loading && integration.content?.register_member) {
		return (
			<div className="register-promo register-member-promo">
				<div dangerouslySetInnerHTML={{ __html: integration.content?.register_member }} />

				<div className={`toggle-content ${open ? 'opened' : ''}`}>
					<div className="members-say">
						<Title level={3} style={{ marginBottom: 30, marginTop: 50 }}>
							Here’s what our members have to say:
						</Title>
						<Row gutter={[30, 30]}>
							<Col md={12} xs={24}>
								<Card bordered={false} className="member-review">
									<strong className="member-review-title">Great Advice!</strong>
									<Paragraph>
										{`
										I just got off my first expert call. She helped me map out my message and walked me through how I
										can look at my email copy differently and gave great suggestions on how to make it more appealing. ${
											!isChannelWise ? 'Thank you getWise!' : ''
										}
									`}
									</Paragraph>
									<strong className="member-review-name">Karen L.</strong>
								</Card>
							</Col>
							<Col md={12} xs={24}>
								<Card bordered={false} className="member-review">
									<strong className="member-review-title">Great Information!</strong>
									<Paragraph>
										{`
										Always feel comfortable with every call that I am getting great expert advice along with a different
                    perspective on my business. Worth every call. Thank you!
									`}
									</Paragraph>
									<strong className="member-review-name">Raymond M.</strong>
								</Card>
							</Col>
							<Col md={12} xs={24}>
								<Card bordered={false} className="member-review">
									<strong className="member-review-title">I won!</strong>
									<Paragraph>
										{`
										In 50 minutes I got the best advice on honing my pitch, I won my first pitch competition and $7500!
									`}
									</Paragraph>
									<strong className="member-review-name">Margot B.</strong>
								</Card>
							</Col>
							<Col md={12} xs={24}>
								<Card bordered={false} className="member-review">
									<strong className="member-review-title">Positive, Actionable Career Advice</strong>
									<Paragraph>
										{isChannelWise
											? 'I just got off my first expert call. She helped me map out my message and walked me through how I can look at my email copy differently and gave great suggestions on how to make it more appealing. '
											: `My call with my getWise expert was very effective. After spending a short time describing my
												situation we moved into a dialogue where she offered advice and tactics that I could implement
												immediately. Her advice was clear and concise. I strongly recommend other people use getWise to
												positively impact their career.`}
									</Paragraph>
									<strong className="member-review-name">Andy M.</strong>
								</Card>
							</Col>
						</Row>
					</div>
				</div>
			</div>
		)
	}

	const defaultSection = isChannelWise ? (
		<>
			<div className="banner">
				<img
					src="https://211381615390-wiseher-media-prod-us-east-1.s3.amazonaws.com/channel-assets/channelwise/Rectangle+269.jpg"
					alt="promo banner"
				/>
			</div>
			<h1>Get the advice you need, when you need it. To accelerate your business or career growth</h1>
			<p>
				Whether it’s how to create more demand for services, entering a new vertical, what you can write off on your
				taxes or help with your resume or interview skills, our experts are here for you!
			</p>
		</>
	) : (
		<>
			<div className="banner">
				<img src={Banner} alt="promo banner" />
			</div>
			<Title level={3} style={{ marginBottom: 20, marginTop: 30 }}>
				The advice you need, when you need it
			</Title>
			<Paragraph>
				Whether it’s how to use Tik Tok for business or what you can write off on your taxes or help with your resume or
				interview skills, our experts are here for you!
			</Paragraph>
		</>
	)

	return (
		<div className="register-promo register-member-promo">
			<Title level={2}>
				{!isChannelWise
					? 'Business or Career Advice from World Class Experts'
					: 'On-Demand Expert Advice for the Channel'}
			</Title>
			<Paragraph>
				Get the support you need to go farther, faster in your business or career for less than your daily latte!
			</Paragraph>
			<div className={`toggle-content ${open ? 'opened' : ''}`}>
				{defaultSection}

				<div className="members-say">
					<Title level={3} style={{ marginBottom: 30, marginTop: 50 }}>
						Here’s what our members have to say:
					</Title>
					<Row gutter={[30, 30]}>
						<Col md={12} xs={24}>
							<Card bordered={false} className="member-review">
								<strong className="member-review-title">Great Advice!</strong>
								<Paragraph>
									{`
										I just got off my first expert call. She helped me map out my message and walked me through how I
										can look at my email copy differently and gave great suggestions on how to make it more appealing. ${
											!isChannelWise ? 'Thank you getWise!' : ''
										}
									`}
								</Paragraph>
								<strong className="member-review-name">Karen L.</strong>
							</Card>
						</Col>
						<Col md={12} xs={24}>
							<Card bordered={false} className="member-review">
								<strong className="member-review-title">Great Information!</strong>
								<Paragraph>
									{`
										Always feel comfortable with every call that I am getting great expert advice along with a different
                    perspective on my business. Worth every call. Thank you!
									`}
								</Paragraph>
								<strong className="member-review-name">Raymond M.</strong>
							</Card>
						</Col>
						<Col md={12} xs={24}>
							<Card bordered={false} className="member-review">
								<strong className="member-review-title">I won!</strong>
								<Paragraph>
									{`
										In 50 minutes I got the best advice on honing my pitch, I won my first pitch competition and $7500!
									`}
								</Paragraph>
								<strong className="member-review-name">Margot B.</strong>
							</Card>
						</Col>
						<Col md={12} xs={24}>
							<Card bordered={false} className="member-review">
								<strong className="member-review-title">Positive, Actionable Career Advice</strong>
								<Paragraph>
									{isChannelWise
										? 'I just got off my first expert call. She helped me map out my message and walked me through how I can look at my email copy differently and gave great suggestions on how to make it more appealing. '
										: `My call with my getWise expert was very effective. After spending a short time describing my
												situation we moved into a dialogue where she offered advice and tactics that I could implement
												immediately. Her advice was clear and concise. I strongly recommend other people use getWise to
												positively impact their career.`}
								</Paragraph>
								<strong className="member-review-name">Andy M.</strong>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
			<Button className="mobile toggle-btn" shape="round" type="default" onClick={() => setOpen(!open)}>
				{open ? 'Less' : 'More'} Info
			</Button>
		</div>
	)
}

export default MemberRegisterPromo
